"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /** When your routing table is too long, you can split it into small modules **/
var goodsRouter = {
  path: '/goods',
  component: _layout.default,
  redirect: '/goods/goodsLibrary',
  name: '菜品管理',
  alwaysShow: true,
  meta: {
    title: '菜品管理',
    icon: 'cuisine'
  },
  children: [{
    path: 'goodsLibrary',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods/goodsManage/index'));
      });
    },
    name: '菜品库',
    meta: {
      title: '菜品库',
      icon: ''
    }
  }, {
    path: 'dishGroupManage',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods/dishGroupManage/index'));
      });
    },
    name: '菜品分组',
    meta: {
      title: '菜品分组',
      icon: ''
    }
  }, {
    path: 'menuTemplateManage',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods/menuTemplateManage/index'));
      });
    },
    name: '菜单模版',
    meta: {
      title: '菜单模版',
      icon: ''
    }
  }, {
    path: 'menuStoreTemplateManage',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods/menuStoreTemplateManage/index'));
      });
    },
    name: '门店菜单',
    meta: {
      title: '门店菜单',
      icon: ''
    }
  }, {
    path: 'productListingAndRemoval',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods/productListingAndRemoval/index'));
      });
    },
    name: '商品上下架',
    meta: {
      title: '商品上下架',
      icon: ''
    }
  }, {
    path: 'syncGoodsLog',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods/syncGoodsLog/index'));
      });
    },
    name: '操作日志',
    meta: {
      title: '操作日志',
      icon: ''
    }
  }]
};
var _default = exports.default = goodsRouter;